import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

const VehicleForm = ({ vehicle, onSave, onCancel, loading }) => {
    const [vehicleNumber, setVehicleNumber] = useState('');
    const [capacity, setCapacity] = useState('');
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        if (vehicle) {
            setVehicleNumber(vehicle.vehicleNumber || '');
            setCapacity(vehicle.capacity || '');
            setIsActive(vehicle.isActive);
        } else {
            setVehicleNumber('');
            setCapacity('');
            setIsActive(true);
        }
    }, [vehicle]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({
            ...vehicle,
            vehicleNumber,
            capacity,
            isActive
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Vehicle Number *</Form.Label>
                <Form.Control type="text" value={vehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Capacity (in tons)</Form.Label>
                <Form.Control type="number" value={capacity} onChange={(e) => setCapacity(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Check type="checkbox" label="Is Active" checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
            </Form.Group>
            <Button variant="secondary" onClick={onCancel} disabled={loading} className="me-2">Cancel</Button>
            <Button variant="primary" type="submit" disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
            </Button>
        </Form>
    );
};

export default VehicleForm;
